import { runbookSystemConstants } from "../constants/runbookSystem.constants";

export function runbookSystem(state = {}, action) {
  switch (action.type) {
    case runbookSystemConstants.GET_ALL_REQUEST:
    case runbookSystemConstants.GET_REQUEST:
    case runbookSystemConstants.GET_BY_ID_REQUEST:
    case runbookSystemConstants.CREATE_REQUEST:
    case runbookSystemConstants.UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
        request: action.payload,
        error: false,
        errorMessage: null,
        success: false,
      };

    case runbookSystemConstants.GET_ALL_SUCCESS:
      return {
        ...state,
        loading: false,
        response: action.payload,
      };

    case runbookSystemConstants.GET_SUCCESS:
      return {
        ...state,
        loading: false,
        paginatedResult: action.payload,
      };

    case runbookSystemConstants.GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        system: action.payload,
      };

    case runbookSystemConstants.CREATE_SUCCESS:
    case runbookSystemConstants.UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case runbookSystemConstants.DELETE_REQUEST:
      return {
        ...state,
        loading: true,
        deleteSuccess: false,
      };

    case runbookSystemConstants.DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteSuccess: true,
      };

    case runbookSystemConstants.CREATE_FAILURE:
    case runbookSystemConstants.UPDATE_FAILURE: {
      // action.payload is the raw axios error — surface whatever the API sent back (the
      // controller returns BadRequest(ex.Message) on a handled error; an unhandled 500
      // instead gets ASP.NET's default ProblemDetails body, hence the `.title` fallback)
      // instead of just a boolean flag, so the form can show the real reason a save failed.
      const data = action.payload?.response?.data;
      let errorMessage =
        (typeof data === "string" ? data : data?.message || data?.title) ||
        action.payload?.message ||
        "An error occurred while saving the system. Please try again.";
      // A raw HTML dev-exception page (local/Development environment) isn't worth dumping
      // into the alert — fall back to the generic message rather than rendering markup as text.
      if (typeof errorMessage === "string" && errorMessage.trim().startsWith("<")) {
        errorMessage = "An error occurred while saving the system. Please try again.";
      }
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage,
      };
    }

    case runbookSystemConstants.GET_ALL_FAILURE:
    case runbookSystemConstants.GET_FAILURE:
    case runbookSystemConstants.GET_BY_ID_FAILURE:
    case runbookSystemConstants.DELETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    default:
      return state;
  }
}
